module.exports = __webpack_public_path__ + "static/media/isign32_ico_app.dc2d7a43.ico";